var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenderSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_482_5788)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5 6.80847H7.5C6.80964 6.80847 6.25 7.36812 6.25 8.05847V33.0585C6.25 33.7488 6.80964 34.3085 7.5 34.3085H32.5C33.1904 34.3085 33.75 33.7488 33.75 33.0585V8.05847C33.75 7.36812 33.1904 6.80847 32.5 6.80847Z",
    stroke: "#051B46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 15.5585H33.5",
    stroke: "#051B46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 4.30847V9.30847",
    stroke: "#051B46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 4.30847V9.30847",
    stroke: "#051B46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_482_5788"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.558472)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderSvg);
export default __webpack_public_path__ + "static/media/calenderSvg.559ce8004e1a9abeb85a3c61b48ed5e8.svg";
export { ForwardRef as ReactComponent };